export function replaceVariables(obj: any, data: any): any {

  
  if (typeof obj === 'string') {
    // Si la chaîne entière est une variable, retourne la valeur brute (objet/tableau)
    const fullMatch = obj.match(/^\{\{(.*?)\}\}$/);
    if (fullMatch) {
      const keys = fullMatch[1].trim().split('.');
      let value = data;
      for (const key of keys) {
        if (value === undefined || value === null) break;
        value = value[key];
      }
        console.log(`🔄 Replaced {{${fullMatch[1]}}} with`, value);

      return value !== undefined ? value : obj;
    }
    // Sinon, remplacement partiel dans la chaîne
    return obj.replace(/\{\{(.*?)\}\}/g, (match, path) => {
      const keys = path.trim().split('.');
      let value = data;
      for (const key of keys) {
        if (value === undefined || value === null) break;
        value = value[key];
      }
      return value !== undefined ? value : match;
    });
  }
  if (Array.isArray(obj)) {
    return obj.map(item => replaceVariables(item, data));
  }
  if (obj && typeof obj === 'object') {
    const newObj: any = {};
    for (const key in obj) {
      newObj[key] = replaceVariables(obj[key], data);
    }
    return newObj;
  }
  return obj;
}